export default __webpack_public_path__ + "static/media/Solped_Generada2.b1e9c1d8.svg";